import { PropsWithChildren } from 'react';

import { x } from '@/style';

import { Text } from '@ui-furniture/elements';

const RowItem = ({ children }: PropsWithChildren) => (
  <Text fontSize='sm' my='sm' lineHeight='1.4'>
    {children}
  </Text>
);

export const GeneralSurveyDescriptionColumn = () => {
  return (
    <x.div display='grid' gridTemplateRows='subgrid' gridRow={'1 / -1'}>
      <x.div gridRow='1 / span 4' />

      <x.div display='grid' gridTemplateRows='subgrid' gridRow='7 / -1'>
        <RowItem>Assessment of Overall Condition</RowItem>
        <RowItem>Roof</RowItem>
        <RowItem>Walls</RowItem>
        <RowItem>Windows</RowItem>
        <RowItem>Doors</RowItem>
        <RowItem>Structural Integrity</RowItem>
        <RowItem>Visible Defects</RowItem>
        <RowItem>Recommendations of Repairs</RowItem>
        <RowItem>Not Immediately Visible Defects</RowItem>
        <RowItem>Secondary Signs of Damp, Rot, Infestation</RowItem>
        <RowItem>Establish Construction Materials/Methods</RowItem>
        <RowItem>Repair Timeline and Consequences of Inaction</RowItem>
        <RowItem>Estimation of Costs For Repairs</RowItem>
        <RowItem>Specific Comments on Energy Efficiency</RowItem>
      </x.div>
    </x.div>
  );
};
